import React, { useState } from "react";
import { TemplateHandler } from "../state_handlers";

export const useTemplateManager = (initialSelections) => {
  const [values, setValues] = useState(initialSelections);

  return [
    values,
    (dataRef, data) => {
      switch (dataRef) {
        case "load":
          return setValues(data);
          break;

        case "delete":
          let valuesAfterDelete = values.filter((value) => value != data);
          return setValues(valuesAfterDelete);
          break;

        case "edit":
          let editedTemplate = new TemplateHandler([data])[0];
          let valuesAfterEdit = values.map((value) => {
            if (value.id == data.id) {
              return editedTemplate;
            } else {
              return value;
            }
          });
          return setValues(valuesAfterEdit);
          break;

        case "create":
          let createdTemplate = new TemplateHandler([data])[0];
          let valuesAfterCreate = [...values, createdTemplate];

          return setValues(valuesAfterCreate);
          break;

        default:
          console.log("Template Setting not mapped to expected action");
          return setValues(values);
      }
    },
  ];
};
